import * as React from 'react';
import * as styles from './styles.css';
import { ArticleHeading4, ArticleParagraph2, LinkButton, useDeviceType } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types';

import mobileAvatar from '../../static/realtorPromoBanner/avatars_mobile.png';
import desktopAvatar from '../../static/realtorPromoBanner/avatars_desktop.png';

export interface IRealtorBannerCardProps {
  url: string;

  onClick(): void;
}

const avatars = {
  desktop: desktopAvatar,
  mobile: mobileAvatar,
};

export const RealtorBannerCard: React.FC<IRealtorBannerCardProps> = ({ onClick, url }) => {
  const isDesktop = useDeviceType() === 'desktop';

  const { avatarSrc, buttonSize } = React.useMemo(() => {
    const avatarSrc = isDesktop ? avatars['desktop'] : avatars['mobile'];
    const buttonSize: IButtonProps['size'] = isDesktop ? 'XS' : 'M';

    return { avatarSrc, buttonSize };
  }, [isDesktop]);

  return (
    <div className={styles['container']}>
      <div className={styles['avatars']}>
        <img src={avatarSrc} alt="avatars" />
      </div>
      <div className={styles['two-column']}>
        <div className={styles['info']}>
          <ArticleHeading4>Бесплатно подберем риелтора</ArticleHeading4>
          <div className={styles['subtext']}>
            <ArticleParagraph2>Ответьте на несколько вопросов и вам позвонят подходящие риелторы</ArticleParagraph2>
          </div>
        </div>
        <div className={styles['action']}>
          <LinkButton href={url} size={buttonSize} onClick={onClick}>
            Подобрать риелтора
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

RealtorBannerCard.displayName = 'RealtorBannerCard';
